import { Badge, Text } from '@change/ds-core-ui';

import { useAdvocacySupport } from './hooks/useAdvocacySupport';

export const AdvocacySupport: React.FC = () => {
	const {
		data: { totalEndorsers, categories },
	} = useAdvocacySupport();

	const gridConfig = categories.map((x) => `${x.count}fr`).join(' ');

	if (totalEndorsers === 0) return null;

	return (
		<div className="mt-8">
			<div className="mb-4 flex justify-between" data-testid="recommender-count-wrapper">
				<Text as="h4" className="font-bold">
					Strong community backing
				</Text>
				<div className="flex items-center gap-1">
					<Badge className="bg-black px-2" label={totalEndorsers} />
					<Text as="span">Recommenders</Text>
				</div>
			</div>

			<div
				className="grid overflow-hidden rounded-full"
				style={{ gridTemplateColumns: gridConfig }}
				data-testid="composition-bar"
				role="img"
				aria-label="Community backing composition by category"
			>
				{categories.map((item) => (
					<div key={`bar-${item.category}`} className="h-2.5" style={{ background: item.color }} role="presentation" />
				))}
			</div>

			<ul className="mt-2.5 flex flex-wrap gap-2.5 md:flex-row" data-testid="legend" aria-label="Legend">
				{categories.map((item) => (
					<li key={`list-${item.category}`} className="flex items-center gap-1">
						<div className="h-2.5 w-2.5 rounded-full" style={{ background: item.color }} aria-hidden="true" />
						<div>{item.category}</div>
					</li>
				))}
			</ul>
		</div>
	);
};
